const ChatView = {
  MobileView: 'MobileView',
  WebView: 'WebView',
  SidebarView: 'SidebarView',
};

export {
  ChatView,
};
